import React, { useMemo } from "react";

import { Order, Language } from "../../../../../../../services";
import { ColumnId } from "../../columns";
import { CellContentRoot } from "..";

import cellProcessing from "./cellProcessing";

const CompanyCellContent: React.FC<CompanyCellContent.Props> = ({
	item,
	language,
}) => {
	const content = useMemo(() => {
		const isCellsReady = !!item?.cellsForTableSettings?.isCellsReady;

		const isLanguageMatched =
			item?.cellsForTableSettings?.lang === language;

		const preparedCell = item?.cellsForTable?.[ColumnId.Company];

		if (
			isCellsReady &&
			isLanguageMatched &&
			preparedCell != null
		) {
			return preparedCell;
		}

		return cellProcessing(item.taxiService, language);
	}, [
		item?.cellsForTable,
		item?.cellsForTableSettings?.isCellsReady,
		item?.cellsForTableSettings?.lang,
		item.taxiService,
		language,
	]);

	return (
		<CellContentRoot alignItems="center" h="100%" w="100%">
			{content}
		</CellContentRoot>
	);
};

declare namespace CompanyCellContent {
	interface Props {
		item: Order.Model;

		language: Language;
	}
}

export default CompanyCellContent;
